import React from 'react'
import PropTypes from 'prop-types'

import './index.scss'

class ExploreLayout extends React.Component {
  render() {
    return (
      <div className="explore-layout-comp">
        <div className="rail-container">{this.props.rail}</div>
        <div className="main-container">{this.props.main}</div>
      </div>
    )
  }
}

ExploreLayout.propTypes = {
  rail: PropTypes.node.isRequired,
  main: PropTypes.node.isRequired,
}
export default ExploreLayout
